import React from 'react'

import { isMailBoxEnv } from '../helpers/helpers'
import CitizenFolderRoutes from './CitizenFolderRoutes'
import MailBoxRoutes from './MailBoxRoutes'

export const DashboardRoutes = () => (isMailBoxEnv ? <MailBoxRoutes /> : <CitizenFolderRoutes />)
